<template>
  <div
    ref="display"
    class="display"
    :style="{
      top:start.y - 25 + 'px',
      left:start.x - 25 + 'px',
      color:complete?'#fff':'black'
    }"
    @click="$emit('myClick')"
  >

    <div class="display_box">
      <ul
        ref="box"
        class="box_arrow"
        :style="{
          top:-index * 19 + 'px'
        }"
        @transitionend="myEnd"
      >
        <i class="arrow_item">→</i>
        <i class="arrow_item">→</i>
      </ul>
    </div>
    <span class="display_tips">{{ complete ? '已完成' : '下载中...' }}</span>
  </div>
</template>
<script>
export default {
  props: {
    start: {
      type: Object,
      default() {
        return {}
      }
    },
    end: {
      type: Object,
      default() {
        return {
          x: 0,
          y: 0
        }
      }
    },
    complete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      index: 1
    }
  },
  watch: {
    complete(newValue) {
      if (newValue) {
        this.$refs.display.style.backgroundColor = '#67c23a'
        setTimeout(() => {
          this.$emit('completeFunc', this.$refs.display)
        }, 600)
      }
    }
  },
  mounted() {
    this.myEnd()
    setTimeout(() => {
      this.$refs.display.style.left = this.end.x - 50 + 'px'
      this.$refs.display.style.top = this.end.y - 50 + 'px'
      this.$refs.display.style.transform = 'scale(1)'
    }, 500)
  },
  methods: {
    myEnd() {
      if (this.index === 0) {
        this.index = 1
        this.$refs.box.style.transition = `0s`
        if (!this.complete) {
          setTimeout(() => {
            this.index = --this.index
            this.$refs.box.style.transition = `top 0.6s`
          }, 500)
        }
      } else {
        if (!this.complete) {
          setTimeout(() => {
            this.index = --this.index
          }, 500)
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
.display {
  width: 50px;
  height: 50px;
  background-color: rgb(187 230 39 / 73%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  transition: all 1s;
  transform: scale(0);
  opacity: 1;
  position: fixed;
  /* box-shadow: 0px 2px 5px; */
  .display_box {
    position: relative;
    width: 100%;
    height: 19px;
    display: flex;
    justify-content: center;
    /* border: 1px solid; */
    overflow: hidden;
    .box_arrow {
      position: absolute;
      margin: 0px;
      padding: 0px;
      transition: top 0.3s;
      top: 0px;
      .arrow_item {
        width: 30px;
        height: 19px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-style: normal;
        transform: rotate(90deg);
      }
    }
  }
  .display_tips {
    font-size: 12px;
  }
}
</style>
